<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 724 720"
    style="enable-background:new 0 0 724 720;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #06a6da;
        }
    </style>
    <g>
        <g>
            <path
                class="st0"
                d="M716.4,346.9c0,8.8,0,17.6,0,26.4c-0.1,0.9-0.4,1.9-0.4,2.8c-0.3,5.8-0.5,11.6-1,17.5
			c-0.8,10-2.2,19.9-3.9,29.7c-5.5,31.4-15.2,61.6-28.9,90.4c-7.6,15.9-16.4,31.1-26.4,45.6c-14.4,21-30.6,40.3-49.3,57.6
			c-6,5.6-12.1,11.1-18.5,16.4c-25.9,21.3-54.2,38.7-85,52c-24.3,10.6-49.4,18.4-75.4,23.3c-16.6,3.2-33.3,5.2-50.2,5.9
			c-0.9,0-1.7,0.3-2.6,0.4c-8.6,0-17.3,0-25.9,0c-0.8-0.1-1.6-0.4-2.3-0.4c-4.7-0.3-9.4-0.6-14.1-1c-12.1-0.9-24-2.6-35.9-4.9
			c-29.3-5.6-57.4-14.9-84.4-27.6c-19.7-9.3-38.5-20.3-56.2-32.9c-13-9.2-25.4-19.2-37-30.1c-10.4-9.8-20.3-20.2-29.5-31.2
			c-16.6-19.9-30.8-41.4-42.7-64.5C41,511.1,36,499.6,31.5,487.9c-8.2-21.5-14.3-43.6-18.2-66.3c-2.4-14-4.1-28.1-4.8-42.4
			c-0.1-2.1-0.6-4.1-0.9-6.1c0-8.8,0-17.6,0-26.4c0.2-0.9,0.4-1.7,0.5-2.6c0.4-4.8,0.6-9.6,1-14.3c1-11.5,2.5-22.9,4.6-34.2
			c6.3-34.7,17.4-67.7,33.7-99.1c7.3-14.1,15.4-27.6,24.6-40.6c10.7-15.3,22.6-29.6,35.7-42.9c11.1-11.4,23-22,35.6-31.8
			c16.5-12.9,33.9-24.3,52.4-34.1c20.5-10.9,41.7-19.9,63.9-26.6c13.9-4.2,27.9-7.7,42.2-10.1c14.8-2.6,29.7-4.3,44.8-4.9
			c0.8,0,1.6-0.3,2.3-0.4c8.5,0,17,0,25.4,0c0.7,0.1,1.4,0.4,2.1,0.4c2.8,0.2,5.6,0.2,8.4,0.5c8.6,0.8,17.2,1.4,25.8,2.6
			c27.7,3.8,54.5,11,80.5,21.2c13.6,5.4,27,11.4,39.8,18.5c8.8,5,17.4,10.4,26.1,15.6c0.8,0.5,1.5,1.1,2.4,1.9
			c-0.8,0.6-1.2,1-1.7,1.3c-7.3,4-14.6,8-21.9,11.9c-4.4,2.4-8.7,4.8-13.1,7.1c-1.3,0.7-2.1,1.6-2,3.2c0.5,6.1,1,12.3,1.5,18.4
			c0.6,7,1.2,14,1.7,21c0.4,4.8,0.7,9.6,1.1,14.3c0.6,7.2,1.2,14.3,1.8,21.5c0.5,6.6,1.1,13.2,1.6,19.8c0.6,7.1,1.2,14.2,1.8,21.3
			c0.4,5,0.8,10,1.3,15c0.3,3.2,0.8,6.3,1.1,9.5c0.1,0.9,0.5,1.9-0.7,2.9c-26-35.5-51.8-70.9-77.8-106.5c-0.9,0.5-1.8,0.9-2.6,1.3
			c-13.4,7.6-26.8,15.2-40.3,22.8c-9.9,5.6-19.8,11.2-29.6,16.8c-2.3,1.3-2.3,1.4-1.4,4c2.9,8.2,5.8,16.4,8.8,24.6
			c7.3,20.3,14.5,40.5,21.8,60.7c5.8,16.3,11.7,32.7,17.5,49c6.8,19,13.6,37.9,20.4,56.9c1.6,4.4,3.1,8.7,4.7,13.1
			c0.8,2.2,1.3,2.3,3.2,0.9c1-0.7,2-1.3,3-1.9c15.7-9,31.3-18,47-27c0.8-0.5,1.7-0.9,2.4-1.5c0.4-0.3,0.6-1.1,0.6-1.6
			s-0.3-1.1-0.5-1.6c-12.8-31.7-25.5-63.3-38.3-95c-4-9.9-8-19.9-12-29.8c-0.3-0.8-0.9-1.6-0.5-2.9c0.6,0.7,1.1,1.2,1.4,1.7
			c2.4,3.5,4.7,7,7.2,10.4c12.7,17.4,25.5,34.9,38.2,52.3c10.6,14.5,21.2,29,31.9,43.6c1,1.4,2,2.7,3,4c1,1.2,1.5,1.3,2.8,0.4
			c0.7-0.5,1.4-1,2.2-1.5c4.2-2.5,8.4-4.9,12.7-7.3c8.3-4.8,16.6-9.6,25-14.3c1.7-1,2.5-2.1,2.2-4c-0.2-1.6-0.3-3.2-0.5-4.8
			c-0.7-7.8-1.4-15.6-2.1-23.4c-0.7-8.2-1.5-16.4-2.2-24.6c-0.7-7.8-1.4-15.6-2.1-23.4c-0.7-8-1.5-16.1-2.2-24.1s-1.5-15.9-2.2-23.9
			c-0.6-6.8-1.2-13.7-1.8-20.5c0-0.4,0.2-0.8,0.3-1.1c0.2,0,0.3,0,0.5,0c2.7,8.8,5.3,17.5,8.1,26.3c2.7,8.8,5.6,17.5,8.4,26.3
			c2.8,8.8,5.6,17.5,8.4,26.3c2.8,8.8,5.6,17.5,8.4,26.3c2.9,8.7,5.4,17.5,8.6,26.4c0.9-0.6,1.5-0.9,2.1-1.3
			c0.8-0.5,1.6-1.1,2.4-1.6c12.1-6.9,24.1-13.9,36.2-20.8c4.4-2.6,8.9-5.1,13.3-7.7c1.7-1,1.8-1.2,1.1-3.1c-0.1-0.4-0.3-0.8-0.4-1.1
			c-7.3-20.2-14.6-40.5-21.9-60.7C635,156,622.7,122,610.4,87.9c-4.6-12.6-9.1-25.3-13.7-37.9c-1-2.7-0.7-3.1,2.3-3.6
			c0.3,0.7,0.7,1.4,0.9,2.1c3.5,9.8,7.1,19.6,10.6,29.3c5.3,14.6,10.5,29.2,15.8,43.8c0.6,1.5,1.5,3,2.5,4.3
			c2.8,3.4,5.7,6.7,8.5,10.1c18.2,22.3,33.6,46.3,45.8,72.4c6.4,13.7,12,27.7,16.6,42.2c9.6,30.4,15.5,61.5,16.3,93.5
			C716,345.2,716.3,346.1,716.4,346.9z M220.7,263.4c-1.3,0.6-2.2,1-3.1,1.5c-10.4,6-20.7,12.1-31.1,18.1
			c-8.2,4.8-16.4,9.6-24.6,14.4c-2.1,1.2-2.2,1.6-1.4,3.9s1.7,4.7,2.5,7c6.6,18.5,13.3,37,19.9,55.5c5.8,16.3,11.7,32.7,17.5,49
			c7.6,21.2,15.2,42.5,22.8,63.7c3.5,9.6,6.9,19.3,10.4,28.9c0.3,0.8,0.7,1.5,1.2,2.6c0.9-0.5,1.5-0.8,2-1.2
			c0.9-0.6,1.8-1.3,2.8-1.9c17.7-10.3,35.4-20.6,53-30.9c3.4-2,3-1.6,1.8-5c-8.7-24.1-17.4-48.1-26.1-72.2c-0.3-0.8-0.6-1.6-0.9-2.5
			c-0.7-2.1-0.6-2.2,1.1-3.3c0.2-0.1,0.4-0.2,0.6-0.4c18.3-11,36.6-22,54.9-32.9c0.7-0.4,1.5-0.8,2.6-1.3c0.5,1.7,1,3.1,1.5,4.5
			c5.8,16.1,11.6,32.2,17.4,48.3c3,8.3,6,16.5,9,24.8c0.3,0.8,0.7,1.5,1.1,2.3c0.7-0.3,1.2-0.4,1.6-0.7c1.8-1.1,3.5-2.3,5.3-3.3
			c17.3-9.6,34.5-19.2,51.8-28.8c2.1-1.2,2.2-1.2,1.3-3.6c-2.5-7-5.1-14-7.7-20.9c-14.1-38.6-28.2-77.2-42.3-115.8
			c-8.3-22.7-16.6-45.3-24.9-68c-0.2-0.6-0.5-1.1-0.9-1.8c-1,0.5-1.7,0.9-2.5,1.3c-6.9,4-13.8,8-20.7,12.1
			c-11.7,6.8-23.5,13.7-35.2,20.5c-2.4,1.4-2.5,1.7-1.5,4.2c2.1,5.5,4.2,10.9,6.2,16.4c6.3,16.6,12.6,33.2,18.9,49.8
			c1,2.5,0.8,2.9-1.5,4.2c-7.1,4-14.2,8.1-21.2,12.1c-11.2,6.5-22.4,12.9-33.7,19.4c-0.6,0.3-1.3,0.6-2.3,1
			C237.6,310.8,229.3,287.3,220.7,263.4z M134.1,564.1c0.7-0.3,1.3-0.5,1.7-0.7c1.7-1.1,3.3-2.2,5-3.2
			c17.3-10.1,34.5-20.1,51.8-30.2c2.3-1.4,2.4-1.4,1.4-4c-4.4-12.1-8.9-24.1-13.4-36.2C160,434,139.5,378.2,118.9,322.4
			c-0.1-0.3-0.3-0.5-0.5-0.9c-0.4,0.1-0.9,0.1-1.2,0.3c-1.8,0.9-3.5,1.9-5.3,2.9c-12.8,7.1-25.6,14.2-38.4,21.3
			c-4.6,2.6-9.2,5.1-13.8,7.7c-2.2,1.2-2.4,1.7-1.5,4c0.7,2,1.5,4.1,2.2,6.1c6.2,16.9,12.4,33.8,18.6,50.7c7,19,13.9,38,20.8,57
			c5.8,15.8,11.5,31.5,17.3,47.3c5.2,14.3,10.5,28.7,15.8,43C133.2,562.4,133.7,563.2,134.1,564.1z"
            />
        </g>
    </g>
</svg>
